import { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { sportsApi } from '../SportsAuthContext';
import { AuthShell, SportsInput, SportsButton } from '../components/AuthShell';

export default function SportsForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await sportsApi.post('/sports/auth/forgot-password', { email, origin: window.location.origin });
      setSent(true);
    } catch {
      toast.error('Could not send reset link. Try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell
      title="Reset Password"
      subtitle="We'll email you a secure reset link."
      footer={<Link to="/sports/login" className="text-[#E63946] font-semibold" data-testid="sports-back-login-link">Back to sign in</Link>}
    >
      {sent ? (
        <div className="rounded-md border border-[#00E676]/40 bg-[#00E676]/10 px-4 py-3 text-sm text-[#00E676]" data-testid="sports-forgot-sent">
          If that email is registered, a reset link is on its way. Check your inbox.
        </div>
      ) : (
        <form onSubmit={submit}>
          <SportsInput label="Email" type="email" testid="sports-forgot-email" value={email}
            onChange={(e) => setEmail(e.target.value)} required placeholder="you@court.com" />
          <SportsButton type="submit" testid="sports-forgot-submit" disabled={busy}>
            {busy ? 'Sending…' : 'Send Reset Link'}
          </SportsButton>
        </form>
      )}
    </AuthShell>
  );
}
